<div class="modal-roles flex flex-col justify-between h-full">
	<div class="modalHeader">
		<div class="flex">
			<div class="titleNewModule">
				<span mat-dialog-title> {{ translateModal.title }} {{ client.name || '' }}</span>
			</div>
			<div class="closeModal">
				<mat-icon (click)="onNoClick()">close</mat-icon>
			</div>
		</div>
	</div>
	<div mat-dialog-content class="modalContent mt-4 h-full">
		<form class="" [formGroup]="formModule">
			<div class="contentGeneral">
				<div class="">
					<div class="form-group">
						<label for="name">{{ translateModal.name }} <span class="asteriks">*</span></label>
						<input
							type="text"
							class="input-app px-3"
							maxlength="50"
							[placeholder]="translateModal.placeholderName"
							formControlName="name"
							id="name"
						/>
						<div *ngIf="f.name.touched && f.name.invalid" class="alert-error">
							<div *ngIf="f.name.errors?.required">
								{{ translateModal.nameRequired }}
							</div>
						</div>
					</div>
					<div class="form-group">
						<label for="module">
							{{ translateModal.systemModule }} <span class="asteriks">*</span></label
						>
						<p-dropdown
							[options]="systemsModules"
							formControlName="module"
							class="w-full"
							optionLabel="name"
							id="module"
							[placeholder]="translateModal.placeholderSystemModule"
						>
							<ng-template pTemplate="selectedItem">
								<div class="system-item client-item-value" *ngIf="formModule.value.module.name">
									<div>{{ formModule.value.module.name }}</div>
								</div>
							</ng-template>
							<ng-template let-systems pTemplate="item" class="container-cardModule">
								<div class="system-item">
									<div>{{ systems.name }}</div>
								</div>
							</ng-template>
						</p-dropdown>
						<div *ngIf="f.module.touched && f.module.invalid" class="alert-error">
							<div *ngIf="f.module.errors?.required">{{ translateModal.systemRequired }}</div>
						</div>
					</div>

					<div class="form-group">
						<label for="domain">
							{{ translateModal.selectDomain }} <span class="asteriks">*</span></label
						>
						<p-dropdown
							[options]="domains"
							formControlName="domain"
							class="w-full"
							optionLabel="name"
							id="domain"
							[placeholder]="translateModal.placeholderSelectDomain || 'Domains'"
						>
							<ng-template pTemplate="selectedItem">
								<div class="domain-item domain-item-value" *ngIf="formModule.value.domain.name">
									<div>{{ formModule.value.domain.name }}</div>
								</div>
							</ng-template>
							<ng-template let-domain pTemplate="item" class="container-cardModule">
								<div class="domain-item">
									<div>{{ domain.name }}</div>
								</div>
							</ng-template>
						</p-dropdown>
						<div *ngIf="f.domain.touched && f.domain.invalid" class="alert-error">
							<div *ngIf="f.domain.errors?.required">{{ translateModal.domainRequired }}</div>
						</div>
					</div>
					<div class="form-group">
						<span class="w-full font-lato text-base"> {{ translateModal.textCustomDomains }} </span>
					</div>
					<div class="form-group">
						<label for="mainDomain"> {{ translateModal.mainDomain }}</label>
						<input
							type="text"
							formControlName="mainDomain"
							id="mainDomain"
							[placeholder]="translateModal.placeholderMainDomain"
							class="input-app"
						/>
					</div>
					<div class="form-group">
						<label for="subDomain"> {{ translateModal.subDomain }}</label>
						<input
							type="text"
							formControlName="subDomain"
							[placeholder]="translateModal.placeholderSubDomain"
							id="subDomain"
							class="input-app"
						/>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div mat-dialog-actions class="footer-modal">
		<div class="px-2">
			<button class="mg-button secundaryButton" (click)="onNoClick()">
				{{ translateModal.buttonCancel }}
			</button>
		</div>
		<div class="pl-2">
			<button
				[disabled]="formModule.invalid"
				class="mg-button primaryButton"
				(click)="createClient()"
			>
				{{ translateModal.buttonSave }}
			</button>
		</div>
	</div>
</div>
